import React from 'react';
import { 
    translate,
    Filter,
    List, 
    Datagrid,
    TextField, 
    TextInput,
    DateInput,
    DateField,
    SearchInput,
    SelectInput,
} from 'react-admin';
import Chip from '@material-ui/core/Chip';
import withStyles from '@material-ui/core/styles/withStyles';
import ShipmentShow from './ShipmentShow'
import BoolNumField from './BoolNumField';
import ErrorBoundary from '../ErrorBoundary';

const quickFilterStyles = {
    root: {
        marginBottom: '0.7em',
    },
};

const QuickFilter = translate(
    withStyles(quickFilterStyles)(({ classes, label, translate }) => (
        <Chip className={classes.root} label={translate(label)} />
    ))
);

export const ShipmentFilter = props => (
    <Filter {...props}>
        <SearchInput source="case_no" alwaysOn  label='Case Numeber'/>
        <DateInput source="bleed_date" />
        <TextInput source="ucn" lable="Unit Control Number" />
        <TextInput source="ssn" lable="SSN" />
        
    </Filter>
);

export const ToshipList = props => (
<ErrorBoundary>  
    <List 
        {...props}
        filters={<ShipmentFilter />}
        perPage={20}
        sort={{ field: 'bleed_date', order: 'DESC' }}
        bulkActionButtons ={false}
        title="Waitting to be shipped"
        >
        <Datagrid    expand={<ShipmentShow />} >
            <TextField source="case_no" label="Case#" />      
            <TextField source="ucn" label="Uint Control#" />
            <TextField source="ssn" lablel="SSN"/>
            <TextField source="volume" lablel="Volume(ml)"/>
            <DateField source="bleed_date" lablel="Bleed date"  locales="en-us" />
            <BoolNumField source="ready_to_ship" lablel="Ready To Ship"/>
        </Datagrid>
    </List>
    </ErrorBoundary>  
);


export default ToshipList